import { calculateTotals as publicCalculateTotals } from './ecom-v1-totals-calculation-totals-calculator.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const calculateTotals: MaybeContext<
  BuildRESTFunction<typeof publicCalculateTotals> & typeof publicCalculateTotals
> = /*#__PURE__*/ createRESTModule(publicCalculateTotals);

export {
  SubscriptionFrequency,
  PaymentOptionType,
  ItemTypeItemType,
  TaxableAddressType,
  PickupMethod,
  ChargeType,
  DiscountType,
  DataFetchType,
  JurisdictionType,
  RateType,
  ManualCalculationReason,
  FallbackReason,
  RuleType,
  WeightUnit,
  AdditionalFeeSource,
} from './ecom-v1-totals-calculation-totals-calculator.universal.js';
export {
  TotalsCalculationEntity,
  CalculateTotalsRequest,
  CalculateTotalsRequestCouponOneOf,
  CalculateTotalsRequestGiftCardOneOf,
  LineItem,
  CatalogReference,
  PhysicalProperties,
  Scope,
  Group,
  SubscriptionSettings,
  ServiceProperties,
  ItemType,
  ItemTypeItemTypeDataOneOf,
  TaxableAddress,
  TaxableAddressTaxableAddressDataOneOf,
  ApiV1AdditionalFee,
  V1TaxDetails,
  Address,
  StreetAddress,
  AddressLocation,
  SelectedShippingOption,
  MerchantDiscountInput,
  SelectedMemberships,
  SelectedMembership,
  CarrierShippingOption,
  ShippingOption,
  DeliveryLogistics,
  PickupDetails,
  DeliveryTimeSlot,
  ShippingPrice,
  MultiCurrencyPrice,
  OtherCharge,
  DeliveryAllocation,
  Carrier,
  Region,
  ApplicableLineItems,
  AppliedDiscount,
  AppliedDiscountDiscountSourceOneOf,
  Coupon,
  MerchantDiscount,
  DiscountRule,
  DiscountRuleName,
  LineItemDiscount,
  AdditionalFee,
  TaxDetails,
  ExternalReference,
  CalculateTotalsResponse,
  CalculatedLineItem,
  LineItemPricesData,
  ItemTaxFullDetails,
  TaxRateBreakdown,
  TaxBreakdown,
  PriceSummary,
  GiftCard,
  TaxSummary,
  TaxCalculationDetails,
  TaxCalculationDetailsCalculationDetailsOneOf,
  AutoTaxFallbackCalculationDetails,
  ApplicationError,
  AggregatedTaxBreakdown,
  ShippingInformation,
  ShippingRegion,
  SelectedCarrierServiceOption,
  SelectedCarrierServiceOptionPrices,
  SelectedCarrierServiceOptionOtherCharge,
  CarrierServiceOption,
  CalculationErrors,
  CalculationErrorsShippingCalculationErrorOneOf,
  Details,
  DetailsKindOneOf,
  ValidationError,
  FieldViolation,
  SystemError,
  CarrierErrors,
  CarrierError,
  MembershipOptions,
  Membership,
  MembershipName,
  MembershipPaymentCredits,
  InvalidMembership,
  V1AdditionalFee,
  CalculateTotalsResponseNonNullableFields,
  CalculateTotalsOptions,
} from './ecom-v1-totals-calculation-totals-calculator.universal.js';
